import type { JDSAvatarV2DefaultProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSAvatarV2DefaultProps>
  ): React.FC<JDSAvatarV2DefaultProps> =>
  (props: JDSAvatarV2DefaultProps) => {
    return <Component {...props} />;
  };
